/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 */

import 'zone.js';  // Included with Angular CLI.
